(function () {
  'use strict';

  /* @ngdoc object
   * @name forgotPassword
   * @description
   *
   */
  angular
    .module('auth.forgotPassword', [
      'ui.router'
    ]);
}());
